import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import slideshow1 from '../../images/slideshow/1.jpg';
import slideshow2 from '../../images/slideshow/2.jpg';
import slideshow3 from '../../images/slideshow/3.jpg';
import slideshow4 from '../../images/slideshow/4.jpg';
import slideshow5 from '../../images/slideshow/5.jpg';
import slideshow6 from '../../images/slideshow/6.jpg';
import slideshow7 from '../../images/slideshow/7.jpg';
import slideshow8 from '../../images/slideshow/8.jpg';
import slideshow9 from '../../images/slideshow/9.jpg';
import slideshow10 from '../../images/slideshow/10.jpg';
import slideshow11 from '../../images/slideshow/11.jpg';
import slideshow12 from '../../images/slideshow/12.jpg';
import slideshow13 from '../../images/slideshow/13.jpg';
import slideshow14 from '../../images/slideshow/14.jpg';

import Iconset from '../icons';

const SlideShowImages = [slideshow1,slideshow2,slideshow3,slideshow4,slideshow5,slideshow6,slideshow7,slideshow8,slideshow9,slideshow10,slideshow11,slideshow12,slideshow13,slideshow14];



const SlideShowTitles = [
	"2014 - Preparing for a show.",
	"2013 - One of the first shows with (the blessed) Antonio",
	"2012 - During the video shoot for 'Running'",
	"2013 - Recording",
	"2013 - First European Tour",
	"2013 - The Horse Whisperer",
	"2014 - The Cat King",
	"2012 - Having fun at the vinyl photoshoot for 'Sadnecessary'",
	"2013 - Red light soundcheck",
	"2014 - Backstage moments: long hair don't care",
	"2014 - Enjoying the seaside",
	"2015 - Red Rocks, a wall of people",
	"2014 - First time road tripping in Australia and New Zealand",
	"2013 - Our first concert in our hometown Kassel"
]


import '../../styles/chapter2/slideshow.scss';
import '../../styles/transition-group.scss';

class SlideShow extends React.Component{

	constructor(props){
		super(props);

		this.state = {
			index : 0,
		}
	}


	changeImage(dir){
		//console.log(dir);
		
		switch(dir){
			case 'prev':
				if(this.state.index > 0){
					this.setState({
						index : this.state.index - 1
					});
				}else{
					this.setState({
						index : SlideShowImages.length-1
					});
				}
			break;
			case 'next':
				if(this.state.index < SlideShowImages.length-1){
					this.setState({
						index : this.state.index + 1
					});
				}else{
					this.setState({
						index : 0
					});
				}
			break;
		}
		//console.log(event.target.dataset.direction);
	}


	render(){
		return (<div className="slideshow">
			<button className="slideshow-close-icon" onClick={this.props.hideSlideShow}>
				<Iconset.close />
			</button>
			<div className="slideshow-holder">
						<button className="slideshow-button prev" data-direction="prev" onClick={()=>this.changeImage('prev')}><Iconset.circleArrowToLeftIcon /></button>
							<ReactCSSTransitionGroup
								component= "div"
								className={"slideshow-inner"}
					      transitionName="fadeDown"
					      transitionAppear={true}
		     				transitionAppearTimeout={500}
					      transitionEnterTimeout={500}
					      transitionLeaveTimeout={300}>
					      <div className="slideshow-inner-container">
						      <figure key={this.state.index}>
								    <h1>Our private snapshots</h1>
										<img src={SlideShowImages[this.state.index]} alt="" />
										<figcaption className="">{SlideShowTitles[this.state.index]}</figcaption>
									</figure>
								</div>
							</ReactCSSTransitionGroup>
						<button className="slideshow-button next" data-direction="next" onClick={()=>this.changeImage('next')}><Iconset.circleArrowToRightIcon /></button>
					</div>
				</div>);
	}
}

export default SlideShow;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/slideshow.js